import React from 'react';
import OrdersList from '../OrdersList';
import OrderDetail from '../../pages/OrderDetail';

function ClientOrdersTab({ clientId, active, itemId }) {
  if (!active) return null;
  if (itemId) {
    return <OrderDetail embedded orderId={itemId} clientId={clientId} />;
  }
  return <OrdersList clientId={clientId} embedded />;
}

export default ClientOrdersTab;
